export default "__VITE_ASSET__Bg33lekX__"